import { ComponentProps } from 'react';

function CommitsStatsCurvedArrow(props: ComponentProps<'svg'>) {
	return (
		<svg
			width="809"
			height="830"
			viewBox="0 0 809 830"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M339.981 795.934C443.555 798.595 553.053 789.209 654.908 765.884C676.967 759.918 670.064 726.912 646.697 731.458C555.95 749.758 464.16 759.833 371.375 760.319C278.595 760.808 154.588 757.351 84.9919 687.802C49.5383 652.32 53.2826 591.078 52.3558 544.662C50.9164 476.396 54.9781 406.983 61.7113 339.037C67.0823 271.037 76.5926 201.834 87.412 134.046C92.9276 97.4279 115.688 38.289 99.2515 4.9102C97.9975 2.13312 93.9111 1.97432 92.4939 3.28341C60.2125 26.5839 58.8749 96.1045 51.9972 132.67C37.9241 213.973 29.3524 294.126 22.0899 375.694C14.1394 474.967 -12.3292 629.453 59.5188 711.367C122.097 786.102 250.082 792.44 339.981 795.934Z"
				fill="var(--color-title)"
			/>
			<path
				d="M770.211 782.642C784.202 773.637 782.113 757.186 767.395 749.793C721.824 728.926 680.763 697.318 635.193 676.447C621.783 670.469 614.179 690.636 624.811 697.87C659.379 721.04 694 742.848 728.568 766.018C717.459 771.043 706.35 776.068 695.242 781.095C677.269 787.217 659.509 787.891 642.846 795.429C630.375 800.399 635.189 816.958 644.565 821.415C682.174 836.516 738.035 803.218 770.211 782.642Z"
				fill="var(--color-title)"
			/>
		</svg>
	);
}

export default CommitsStatsCurvedArrow;
